// @codekit-prepend "slick/slick.js"

$(document).ready(function(){
	$('.slideshow').slick({
		infinite: true,
		speed: 1100,
		fade: true,
		cssEase: 'cubic-bezier(0.445, 0.050, 0.550, 0.950)',
		adaptiveHeight: true
	});
});
